import React from 'react'
import i18n from 'i18n'
import { OmInput } from '@owma/kit'
import styles from './style.module.scss'
import noteIcon from 'assets/images/calendar/note-icon.svg'

interface DescriptionSelectorProps {
  value: string
  onChange: (value: string) => void
}

const DescriptionSelector: React.FC<DescriptionSelectorProps> = ({ value, onChange }) => {
  return (
    <div className={styles.descriptionSelector}>
      <div className={styles.titleIconWrapper}>
        <img src={noteIcon} alt="Notes" className={styles.titleIcon} />
      </div>
      <div className={styles.textareaWrapper}>
        <OmInput
          multiline
          className={styles.textarea}
          placeholder={i18n.t('todo.editor.addDescription')}
          value={value}
          onChange={onChange}
          autoSize={{ minRows: 3 }}
        />
      </div>
    </div>
  )
}

export default DescriptionSelector
